import { IOtherChangeViewModel } from '../types/otherChangeViewModel'

export class otherChangeViewModel implements IOtherChangeViewModel
{
    leaseNumber: string = ''
    isActiveLease: boolean = false
    hasExistingOtherChangeRequest: boolean = false
    existingOtherChangeRequestId: string = ''
    referenceNumber: string = ''
}